<script>
import { Line } from 'vue-chartjs'
import annotationPlugin from 'chartjs-plugin-annotation'

export default {
  name: 'TimeSeriesReportChart',
  extends: Line,
  props: {
    report: {
      type: Object,
      default: () => null
    },
    analysis: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: []
      },

      chartColors: [
        {
          backgroundColor: 'rgba(75,192,192,0.2)',
          borderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: 'rgba(75,192,192,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(75,192,192,1)'
        },
        {
          backgroundColor: 'rgba(255,99,132,0.2)',
          borderColor: 'rgba(255,99,132,1)',
          pointBackgroundColor: 'rgba(255,99,132,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(255,99,132,1)'
        },
        {
          backgroundColor: 'rgba(54,162,235,0.2)',
          borderColor: 'rgba(54,162,235,1)',
          pointBackgroundColor: 'rgba(54,162,235,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(54,162,235,1)'
        },
        {
          backgroundColor: 'rgba(255,206,86,0.2)',
          borderColor: 'rgba(255,206,86,1)',
          pointBackgroundColor: 'rgba(255,206,86,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(255,206,86,1)'
        }
      ],

      scales: {},
      annotations: [],
    }
  },
  mounted () {
    this.addPlugin(annotationPlugin)

    this.initChartData()

    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: this.scales,
      annotation: {
        annotations: this.annotations
      }
    })
  },
  methods: {
    getResultsBySubset (subset) {
      return this.report.data.filter(item => item.subset == subset).map(item => {
        const sample_result = item.sample_results.find(result => result.analysis === this.analysis.analysis)
        return sample_result ? {
          ...sample_result,
          starts_at: item.starts_at
        } : { value: null }
      }).flat()
    },

    initChartData () {
      // set labels to starts_at dates
      const dates = this.report.data.filter(item => item.subset == this.report.subsets[0]).map((item, index) => {
        return {
          label: index + 1,
          starts_at: item.starts_at
        }
      })
      this.chartData.labels = dates.map(date => date.label)

      // get all subsets that have the analysis sample results
      const subsets = Object.values(this.report.subsets).filter(subset => {
        return this.report.data.find(item => {
          return item.subset == subset && item.sample_results.find(result => result.analysis === this.analysis.analysis)
        })
      })

      // set datasets
      this.chartData.datasets = subsets.map((subset, index) => {
        // get data for each subset
        const data = dates.map(({ starts_at }) => {
          const result = this.getResultsBySubset(subset).find(result => result.starts_at === starts_at)
          return result ? result.value : null
        })

        return {
          label: subset,
          backgroundColor: this.chartColors[index].backgroundColor,
          borderColor: this.chartColors[index].borderColor,
          pointBackgroundColor: this.chartColors[index].pointBackgroundColor,
          pointBorderColor: this.chartColors[index].pointBorderColor,
          pointHoverBackgroundColor: this.chartColors[index].pointHoverBackgroundColor,
          pointHoverBorderColor: this.chartColors[index].pointHoverBorderColor,
          data,
          spanGaps: true,
          borderWidth: 2
        }
      })

      const analyte = this.report.analytes.find(item => item.analyte_id === this.analysis.analyte_id)

      // set yAxes min and max
      if ((analyte.range_min && !isNaN(Number(analyte.range_min))) && (analyte.range_max && !isNaN(Number(analyte.range_max)))) {
        this.scales.yAxes = [
          {
            ticks: {
              min: Number(analyte.range_min),
              max: Number(analyte.range_max)
            }
          }
        ]
      }

      // set acceptable range boxes
      // range_very_low and range_very_high
      if ((analyte.range_very_low && !isNaN(Number(analyte.range_very_low))) && (analyte.range_very_high && !isNaN(Number(analyte.range_very_high)))) {
        this.annotations.push({
          type: 'box',
          yScaleID: 'y-axis-0',
          yMin: Number(analyte.range_very_low),
          yMax: Number(analyte.range_very_high),
          backgroundColor: 'rgba(46, 204, 113, 0.3)',
          borderWidth: 1
        })
      }

      // range_low and range_high
      if ((analyte.range_low && !isNaN(Number(analyte.range_low))) && (analyte.range_high && !isNaN(Number(analyte.range_high)))) {
        this.annotations.push({
          type: 'box',
          yScaleID: 'y-axis-0',
          yMin: Number(analyte.range_low),
          yMax: Number(analyte.range_high),
          backgroundColor: 'rgba(46, 204, 113, 0.3)',
          borderWidth: 1
        })
      }
    }
  }
}
</script>
